import React from 'react';

import {
  formatujDatePelna,
  formatujMiejsce,
  formatujSzczegoly,
  rozbijDate,
} from '../../utils/koncerty-format';

/**
 * Jeden koncert na liście.
 *
 * Przy wpisach bez pełnej daty w kolumnie z datą pokazujemy sam rok — ale nie
 * w archiwum, gdzie rocznik stoi już w nagłówku sekcji (rokWNaglowku). Kolumna
 * zostaje wtedy pusta, żeby miejscowości nadal były w jednej linii pionowej.
 */
function KoncertWiersz({ koncert, rokWNaglowku }) {
  const data = rozbijDate(koncert.date);
  const szczegoly = formatujSzczegoly(koncert);
  const dataPelna = formatujDatePelna(koncert.date);

  return (
    <li
      className={koncert.highlight ? 'koncert koncert--wyrozniony' : 'koncert'}
    >
      {data ? (
        <div className="koncert__data">
          <span className="koncert__dzien">
            {data.dzien < 10 ? '0' + data.dzien : data.dzien}
          </span>
          <span className="koncert__miesiac">
            {data.miesiacSkrot} {data.rok}
          </span>
        </div>
      ) : (
        <div className="koncert__rok">{rokWNaglowku ? '' : koncert.year}</div>
      )}

      <div className="koncert__opis">
        <span className="koncert__miejscowosc">{formatujMiejsce(koncert)}</span>
        {(szczegoly || koncert.time) && (
          <span className="koncert__szczegoly">
            {[koncert.time, szczegoly].filter(Boolean).join(' · ')}
          </span>
        )}
      </div>

      {koncert.url && (
        <div className="koncert__akcja">
          <a
            href={koncert.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={
              'Szczegóły koncertu w ' +
              koncert.city +
              (dataPelna ? ', ' + dataPelna : '')
            }
          >
            Szczegóły
          </a>
        </div>
      )}
    </li>
  );
}

export default KoncertWiersz;
